import React from 'react';
import config from '../config';

const Footer: React.FC = () => {
  return (
    <footer className='footer'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-6'>
            <span>
              Copyright © {new Date().getFullYear()} {config.APP_NAME}
            </span>
          </div>
          <div className='col-md-6 text-end'>
            <span>Version {config.APP_VERSION}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
